import styled from "styled-components";
import { FormattedMessage } from "@/i18n/i18n-client";
import { EmptyCartIcon } from "@/assets/Icons/EmptyCartIcon";
import { EmptyState } from "@/components/UtilityComponents/EmptyState";
import { FlexRow, FlexCol, P } from "@/shared/globals";
import LoadingSpinner from "@/shared/globals/UiElements/LoadingSpinner";
import FilterTags from "../../../default/components/Filter/components/FilterTags";
import { FilterAndSortProps } from "../../../types";
import Filter from "./Filter";
import { Sorting } from "./Sorting";
import { Pagination } from "@/components/Pagination/Pagination";
import { useSearchParams } from "@/i18n/i18n-navigation";
import { parseSearchParams } from "@/shared/utils/search-params";
import ProductsList from "../../elements/ProductsList";

const DesktopFilterSort = ({
  products,
  itemPerPage,
  productsTotalCount,
  offset,
  loading,
  collectionPageId,
  collectionPageTitle,
}: FilterAndSortProps) => {
  const searchParams = useSearchParams();
  const queries = parseSearchParams(searchParams);
  const searchQuery = queries.query || collectionPageTitle;
  const hasFilters =
    (queries.filters &&
      [...(queries.filters as string[])].some((filter) => filter.length)) ||
    queries.minPrice ||
    queries.maxPrice;

  return (
    <FlexRow alignItems="start" margin="40px 0 0">
      <Filter collectionPageId={collectionPageId} loading={loading} />

      <StyledFlexCol>
        {(searchQuery || hasFilters) && (
          <ItemsWrapper alignItems="start" spacing="xl">
            {searchQuery && (
              <SearchText>
                <FormattedMessage
                  defaultMessage="Search Results For"
                  id="EK/esq"
                />{" "}
                {'"' + searchQuery + '"'}{" "}
                <span style={{ opacity: 0.4 }}>
                  <FormattedMessage
                    defaultMessage="[{resultsCount} Results]"
                    id="KkAaz1"
                    values={{ resultsCount: productsTotalCount }}
                  />
                </span>
              </SearchText>
            )}
            {hasFilters && (
              <FilterTagsWrapper>
                <FilterTags />
              </FilterTagsWrapper>
            )}
          </ItemsWrapper>
        )}
        <Sorting />
        {loading ? (
          <LoadingSpinner />
        ) : products?.length === 0 ? (
          <EmptyState
            title={
              queries.filters || queries.minPrice || queries.maxPrice ? (
                <FormattedMessage
                  defaultMessage="There are no products match your search criteria"
                  id="i0zpgh"
                />
              ) : (
                <FormattedMessage
                  defaultMessage="There are no products added yet"
                  id="dxKBho"
                />
              )
            }
            image={<EmptyCartIcon />}
          />
        ) : (
          <>
            <ProductsList products={products} />
            <Pagination
              offset={offset!}
              itemPerPage={itemPerPage!}
              totalCount={productsTotalCount!}
            />
          </>
        )}
      </StyledFlexCol>
    </FlexRow>
  );
};

export default DesktopFilterSort;

// Styles

const SearchText = styled(P)`
  font-size: 18px;
  font-weight: 600;
  width: 100%;
  word-break: break-word;
`;

const FilterTagsWrapper = styled.div`
  > div {
    width: 100%;
    margin-left: 0;
    margin-top: 0;
  }
`;

const ItemsWrapper = styled(FlexCol)`
  padding: 20px 0;
  box-shadow: inset 0px -1px 0px 0px #eeeeee;
`;

const StyledFlexCol = styled.div`
  width: 100%;
`;
